import { render, staticRenderFns } from "./FormAssetImage.vue?vue&type=template&id=63cf8321&scoped=true&lang=pug"
import script from "./FormAssetImage.vue?vue&type=script&lang=js"
export * from "./FormAssetImage.vue?vue&type=script&lang=js"
import style0 from "./FormAssetImage.vue?vue&type=style&index=0&id=63cf8321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf8321",
  null
  
)

export default component.exports